import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "gfu-project-description js-main-content" }
const _hoisted_2 = { class: "gfu-project-description-section-pledge" }
const _hoisted_3 = { class: "gfu-project-contents-section" }
const _hoisted_4 = {
  key: 1,
  class: "gfu-project-description-section"
}
const _hoisted_5 = { class: "gfu-project-contents-section" }
const _hoisted_6 = {
  key: 1,
  class: "gfu-project-description-section"
}
const _hoisted_7 = { class: "gfu-project-description-section" }
const _hoisted_8 = { class: "gfu-layout-wrapper gfu-layout-wrapper--extranarrow gfu-4of5--l gfu-3of5--xl" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_table_of_contents = _resolveComponent("table-of-contents")
  const _component_skeleton_table_of_contents = _resolveComponent("skeleton-table-of-contents")
  const _component_project_section_rewards = _resolveComponent("project-section-rewards")
  const _component_skeleton_products_list = _resolveComponent("skeleton-products-list")
  const _component_project_section_addons = _resolveComponent("project-section-addons")
  const _component_project_recommendations = _resolveComponent("project-recommendations")
  const _component_mini_wizard_manager_with_loading = _resolveComponent("mini-wizard-manager-with-loading")

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_ctx.isTableOfContentsLoaded)
      ? (_openBlock(), _createBlock(_component_table_of_contents, { key: 0 }))
      : (_openBlock(), _createBlock(_component_skeleton_table_of_contents, { key: 1 })),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!!$options.projectSectionRewardsModel)
          ? (_openBlock(), _createBlock(_component_project_section_rewards, _normalizeProps(_mergeProps({ key: 0 }, $options.projectSectionRewardsModel)), null, 16 /* FULL_PROPS */))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_skeleton_products_list, {
                layout: _ctx.listLayoutTypes.column
              }, null, 8 /* PROPS */, ["layout"])
            ]))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!!$options.projectSectionAddonsModel)
          ? (_openBlock(), _createBlock(_component_project_section_addons, _normalizeProps(_mergeProps({ key: 0 }, $options.projectSectionAddonsModel)), null, 16 /* FULL_PROPS */))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_skeleton_products_list, {
                layout: _ctx.listLayoutTypes.grid
              }, null, 8 /* PROPS */, ["layout"])
            ]))
      ])
    ]),
    _createElementVNode("aside", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_project_recommendations, {
          quantity: 12,
          source: "project-rewards",
          "exclude-project-ids": $options.excludeProjectIds,
          "data-qa": "rewards-view:Recommendations"
        }, null, 8 /* PROPS */, ["exclude-project-ids"])
      ])
    ]),
    _createVNode(_component_mini_wizard_manager_with_loading, { "mini-wizard-model": _ctx.miniWizardModel }, null, 8 /* PROPS */, ["mini-wizard-model"])
  ]))
}